<template>
  <div>
    <b-form-group class="m-4">
      <b-form-group
        label-cols-sm="3"
        label="Neue Email Addresse"
        label-align-sm="right"
      >
        <b-form-input id="email"
                      v-model="newEmail">
        </b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        :label="!validation ? 'Email Addresse wiederholen' : 'OK'"
        label-align-sm="right"
      >
        <b-form-input id="confirmEmail"
                      v-model="confirmEmail">
        </b-form-input>
      </b-form-group>
    </b-form-group>
  </div>
</template>

<script>
    export default {
      name: "email-input",
      data:()=>({
        newEmail:'',
        confirmEmail:''
      }),
      computed:{
        validation(){
          return this.newEmail === this.confirmEmail && this.newEmail ? this.emitEmail() : null
        }
      },
      methods:{
        emitEmail(){
          console.log('EMAIL OK:::')
          this.changeEmail = !this.changeEmail
          this.$emit('emitEmail',this.newEmail)
          return true

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/email-input.vue